import React from 'react';

// Renders text with an optional highlighted word wrapped in a styled span
export function renderTextWithHighlight(text: string | undefined, highlightWord?: string): React.ReactNode {
    if (!text) return null;

    if (highlightWord && text.includes(highlightWord)) {
        const parts = text.split(highlightWord);
        return (
            <>
                {parts[0]}
                <span className="font-bold italic">{highlightWord}</span>
                {parts[1]}
            </>
        );
    }

    return text;
}
